import { PureComponent, Component, } from 'react';
import * as language from '../constants/languages';
import Plus from '../assets/svg/plus.svg'
import Minus from '../assets/svg/minus.svg'
import '../styles/ProductListingComponent.css'
import { useNavigate } from 'react-router-dom';
import { Spinner } from "react-bootstrap"
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { IoIosCart } from "react-icons/io";
import CompanyLogo from "../assets/header_logo.png";

class ProductsListingComponent extends Component {

    constructor(props) {
        super(props);
        this.branchId = localStorage.getItem('storeId');

        this.state = {
            currencySymbol: '',
            data: [],
            productData: this.props.productData,
            snackopen: false,
            message: ''
        }
    }
    async cartQty() {

        try {

            const cart = localStorage.getItem('cartItems')
            if (cart) {
                this.cartItems = JSON.parse(cart);
                for (let i of this.state.productData) {
                    const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == i.productId);
                    if (elementsIndex != -1) {
                        i.cartQty = this.cartItems.customerCartItems[elementsIndex].qty
                    }
                    else {
                        i.cartQty = 0
                    }
                }

                for (let i = 0; i < this.state.productData.length; i++) {
                    if (this.state.productData[i].cartQty > 0) {
                        this.setState({
                            ['quantity_' + (this.state.productData[i].productId)]: this.state.productData[i].cartQty,
                            ['value_' + (this.state.productData[i].productId)]: null,
                        })
                    }
                    else {
                        this.setState({
                            ['quantity_' + (this.state.productData[i].productId)]: 0,
                            ['value_' + (this.state.productData[i].productId)]: null,
                        })
                        this.state.productData[i].cartQty = 0
                    }
                }
            }
            else {

                for (let i = 0; i < this.state.productData.length; i++) {
                    this.setState({
                        ['quantity_' + (this.state.productData[i].productId)]: 0,
                        ['value_' + (this.state.productData[i].productId)]: null,
                    })

                    this.state.productData[i].cartQty = 0

                }
            }
            this.setState({
                data: this.state.productData
            })
        }
        catch (e) { console.log(e, 'error') };
    }

    qtyChangeEvent = (data) => {
        // if (data.token != 0) {
        this.cartQty();
        // }
    }
    // componentDidUpdate(prevProps) {
    //     if (prevProps.productData != this.state.productData) {
    //     console.log('inside')

    //         this.cartQty()
    //     }
    // }

    componentDidMount() {
        this.cartQty()
        this.getCompanyInfo();
        window.addEventListener('productQtyChange', this.qtyChangeEvent)

    }



    componentWillUnmount() {
        window.removeEventListener('productQtyChange', this.qtyChangeEvent);
    }
    updatePage() {
        this.setState({
            productData: this.props.productData
        }, () => {
            this.cartQty()
        })
    }
    componentDidUpdate(prevProps) {
        if (this.state.productData[0]?.productId !== this.props.productData[0]?.productId) {
            this.updatePage()
        }
    }
    //get sotre name
    async getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')
        // console.log(value)
        if (value === null || value === undefined) {
            this.companyInfo = null;
            this.setState({
                currencySymbol: ""
            })
        } else {
            this.companyInfo = JSON.parse(value);
            this.setState({
                currencySymbol: this.companyInfo.currencySymbol
            })
        }
        // console.log(this.state.currencySymbol, 'CurrencySymbol state');


    }
    // quantity select
    async quantityPressed(itemIndex, valueAction, productPrice, productId, productData, productListIndex, e) {
        e.stopPropagation()
        this.props.addedItemToCart(1, productData);

        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        if (this.state['value_' + itemIndex] == null) {
            if (valueAction === 'increment') {
                // await this.setState({
                //     spinnerOverlay: true,

                // })
                this.cartAddRemove(productId, 1, itemIndex, productData) //add qny to cart

            } else {
                if (this.state['quantity_' + itemIndex] != this.incrementValue) {
                    // await this.setState({
                    //     spinnerOverlay: true,
                    // })
                    this.cartAddRemove(productId, 0, itemIndex, productData) //reduce qny to cart
                } else {
                    this.removeItem(productId, productData, productListIndex);
                }
            }
        }

    }

    // add/remove cart
    cartAddRemove(id, action, itemIndex, productData) {
        this.cartItemsJson = localStorage.getItem('cartItems');

        if (!this.cartItemsJson) {
            this.cartItems = {
                customerCartItems: [
                ],
                branchId: parseInt(this.branchId),
                companyId: language.companyidValue
            }
        } else {
            this.cartItems = JSON.parse(this.cartItemsJson);
        }
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        if (action == 1) { //add to cart

            if (productData.isStockAvailable == true) {

                const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == productData.productId)
                if (this.branchId == this.cartItems.branchId) {
                    var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue);
                    if (productData.allowNegativeStock == true || requiredQty <= (productData.stock ?? 0)) {
                        if (elementsIndex == -1) {
                            this.cartItems.customerCartItems = [
                                ...this.cartItems.customerCartItems,
                                {
                                    product: productData,
                                    qty: this.incrementValue,
                                    variantId: null
                                }
                            ]
                        } else {
                            this.cartItems.customerCartItems[elementsIndex] = {
                                product: this.cartItems.customerCartItems[elementsIndex].product,
                                qty: this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue,
                                variantId: this.cartItems.customerCartItems[elementsIndex].variantId
                            }
                        }

                        localStorage.setItem('cartItems', JSON.stringify(this.cartItems));
                        const event = new CustomEvent('productQtyChange');
                        window.dispatchEvent(event)
                        this.setState({
                            ['quantity_' + itemIndex]: this.state['quantity_' + itemIndex] + this.incrementValue,
                            // spinnerOverlay: false
                        })
                        // Toast.show(language.itemAddedTocart);
                    } else {
                        this.setState({
                            message: language.cartAddRemove,
                            snackopen: true
                        })

                    }

                } else {
                    this.setState({
                        message: language.anotherBranch,
                        snackopen: true
                    })
                }

            } else {
                this.setState({
                    message: language.cartAddRemove,
                    snackopen: true
                })
            }

        } else { //reduce from cart
            if (this.branchId == this.cartItems.branchId) {
                const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == id);
                if (elementsIndex > -1) {
                    var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty - this.incrementValue);
                    this.cartItems.customerCartItems[elementsIndex] = {
                        product: this.cartItems.customerCartItems[elementsIndex].product,
                        qty: (requiredQty < 0 ? 0 : requiredQty),
                        variantId: this.cartItems.customerCartItems[elementsIndex].variantId,
                    }
                    localStorage.setItem('cartItems', JSON.stringify(this.cartItems));

                    const event = new CustomEvent('productQtyChange');

                    window.dispatchEvent(event)
                    this.setState({
                        ['quantity_' + itemIndex]: this.state['quantity_' + itemIndex] - this.incrementValue,
                    })
                    // Toast.show(language.itemReducedFromCart);


                }

            } else {
                this.setState({
                    message: language.anotherBranch,
                    snackopen: true
                })
            }

        }
    }

    // add to cart
    async addToCart(id, productData, index, e) {
        this.props.addedItemToCart(1, productData);

        e.stopPropagation()
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        // this.branchId = this.storage.getString('storeId');

        if (productData.isStockAvailable == true) {

            this.cartItemsJson = localStorage.getItem('cartItems');

            if (this.cartItemsJson == null) {
                this.cartItems = {
                    customerCartItems: [
                    ],
                    branchId: parseInt(this.branchId),
                    companyId: language.companyidValue
                }
            } else {
                this.cartItems = JSON.parse(this.cartItemsJson);
            }



            const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == productData.productId)
            if (this.branchId == this.cartItems.branchId) {
                var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue);

                if (productData.allowNegativeStock == true || requiredQty <= (productData.stock ?? 0)) {
                    if (elementsIndex == -1) {
                        this.cartItems.customerCartItems = [
                            ...this.cartItems.customerCartItems,
                            {
                                product: productData,
                                qty: this.incrementValue,
                                variantId: null
                            }
                        ]
                    } else {
                        this.cartItems.customerCartItems[elementsIndex] = {
                            product: this.cartItems.customerCartItems[elementsIndex].product,
                            qty: this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue,
                            variantId: this.cartItems.customerCartItems[elementsIndex].variantId
                        }
                    }
                    this.setState({
                        ['quantity_' + id]: this.state.productData[index].cartQty + this.incrementValue,
                        // spinnerOverlay: false
                    })
                    localStorage.setItem('cartItems', JSON.stringify(this.cartItems));

                    const event = new CustomEvent('productQtyChange');
                    window.dispatchEvent(event)

                    this.setState({
                        message: language.itemAddedTocart,
                        snackopen: true
                    })
                } else {
                    this.setState({
                        message: language.cartAddRemove,
                        snackopen: true
                    })
                }

            } else {
                this.setState({
                    message: language.anotherBranch,
                    snackopen: true
                })
            }




        } else {
            this.setState({
                message: language.cartAddRemove,
                snackopen: true
            })
        }

    }


    // remove the product
    async removeItem(id, productData, index) {

        this.cart = localStorage.getItem('cartItems');
        this.cartItems = JSON.parse(this.cart);
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }

        const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == id);
        this.cartItems.customerCartItems.splice(elementsIndex, 1);
        localStorage.setItem('cartItems', JSON.stringify(this.cartItems));
        if (this.cartItems.customerCartItems.length == 0) {
            localStorage.removeItem('cartItems')
        }
        this.setState({
            message: language.removedFromCart,
            snackopen: true
        })
        const event = new CustomEvent('productQtyChange');

        window.dispatchEvent(event)

    }

    action = (
        <>

            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => this.setState({
                    snackopen: false
                })}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );
    render() {
        return (
            <div className='product-list-container' >
                {
                    this.state.data?.map((productData, index) => (
                        <div className='listWrapper' onClick={() => this.props.navigate(`/Productdetails/${productData.productId}`)} key={index}>

                            {/* ── Offer badge ── */}
                            {(() => {
                                const effectivePrice = productData.oRate != null ? productData.oRate : productData.sRate;
                                const listPrice = productData.mrp != null ? productData.mrp : productData.sRate;
                                return effectivePrice < listPrice
                                    ? <p className='offerTag'>{productData.savedPercentage}% OFF</p>
                                    : null;
                            })()}

                            {/* ── Product image (no cropping & safe fallback) ── */}
                            <div className='card-image-wrap'>
                                <img
                                    src={(productData.tblProductImages && productData.tblProductImages.length > 0 && productData.tblProductImages[0].image) ? productData.tblProductImages[0].image : CompanyLogo}
                                    className='image-featured'
                                    alt={productData.productName}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = CompanyLogo;
                                    }}
                                />
                            </div>

                            {/* ── Card body ── */}
                            <div className='card-body'>

                                {/* Name */}
                                <p className='card-product-name'>{productData.productName}</p>
                                {productData.regionalLanguage && productData.regionalLanguage !== ""
                                    && <p className='card-regional'>{productData.regionalLanguage}</p>}

                                {/* Stock + GST inline */}
                                <div className='card-stock-row'>
                                    {productData.isStockAvailable === false
                                        ? <p className='card-stock-out'>{language.outStockLabel}</p>
                                        : <p className='card-stock-in'>{language.inStockLabel}</p>
                                    }
                                    <p className='card-gst-label'>Excluding 18% GST</p>
                                </div>

                                {/* Price — single line */}
                                <div className='card-price-section'>
                                    <div className='card-price-row'>
                                        {(() => {
                                            const effectivePrice = productData.oRate != null ? productData.oRate : productData.sRate;
                                            const listPrice = productData.mrp != null ? productData.mrp : productData.sRate;
                                            const hasDiscount = effectivePrice < listPrice;
                                            return (
                                                <>
                                                    {hasDiscount && (
                                                        <p className='card-mrp'>
                                                            {this.state.currencySymbol} {(listPrice * productData.incrementValue).toFixed(2)}
                                                        </p>
                                                    )}
                                                    <p className='card-selling-price'>
                                                        {this.state.currencySymbol} {(effectivePrice * productData.incrementValue).toFixed(2)}
                                                    </p>
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>

                                <div className='card-divider' />

                                {/* ── Cart action ── */}
                                {language.type === 0 && (
                                    <div className='card-action' onClick={e => e.stopPropagation()}>
                                        {productData.cartQty > 0 && productData.isStockAvailable !== false ? (
                                            <div className='quantityWrapperFeaturedProducts'>
                                                <div onClick={(e) => this.quantityPressed(productData.productId, 'decrement', productData.sRate, productData.productId, productData, (index + 1), e)}>
                                                    <img src={Minus} alt='-' />
                                                </div>
                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {this.props.isRefetching && this.props.currentlyFetchingId === productData.productId
                                                        ? <Spinner animation="border" size='sm' style={{ width: 14, height: 14 }} />
                                                        : <p style={{ fontFamily: 'Poppins-Regular', margin: 0, fontSize: 13, fontWeight: 600 }}>
                                                            {this.state['quantity_' + productData.productId]}
                                                            {productData.unit && productData.unit !== '-- None --' ? ` ${productData.unit}` : ''}
                                                          </p>
                                                    }
                                                </div>
                                                <div onClick={(e) => this.quantityPressed(productData.productId, 'increment', productData.sRate, productData.productId, productData, (index + 1), e)}>
                                                    <img src={Plus} alt='+' />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='cartWrapper' onClick={(e) => this.addToCart(productData.productId, productData, index, e)}>
                                                {this.props.isRefetching && this.props.currentlyFetchingId === productData.productId
                                                    ? <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
                                                        <Spinner animation="border" size='sm' style={{ width: 18, height: 18 }} />
                                                      </div>
                                                    : <p className='cart-style'>
                                                        <IoIosCart style={{ fontSize: 15 }} /> {language.addToCartLabel}
                                                      </p>
                                                }
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                    ))
                }
                <Snackbar
                    open={this.state.snackopen}
                    autoHideDuration={2000}
                    onClose={() => this.setState({ snackopen: false })}
                    message={this.state.message}
                    action={this.action}
                    ContentProps={{
                        style: { backgroundColor: '#388E3C' } // ✅ Green
                    }}
                />
            </div >
        )
    }
}


export default function (props) {
    const navigate = useNavigate()
    return <ProductsListingComponent {...props}
        key={props.page}
        navigate={navigate} />;
}

